(function redirectTabToVwChannel() {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has('tab')) {
    const tabValue = urlParams.get('tab');
    
    // Replace 'tab' with 'vwChannelSectionName'
    urlParams.delete('tab');
    urlParams.set('vwChannelSectionName', tabValue);

    // Reconstruct the final URL preserving the path and hash (#)
    const newUrl = `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`;

   // We use replace to not ruin the browsing history (SEO/Back button friendly)
    window.location.replace(newUrl);
  }
})();